import { useContactStore } from '../../store/contactStore'
import { AU_STATES, AU_BBOX } from '../../constants/auStates'

export default function RegionFilter() {
  const { filters, setFilters, fitBounds } = useContactStore()
  const selectedState = filters.region

  const handleStateClick = (code: string, bbox: [number, number, number, number]) => {
    if (selectedState === code) {
      setFilters({ region: null })
      fitBounds?.(AU_BBOX)
    } else {
      setFilters({ region: code })
      fitBounds?.(bbox)
    }
  }

  return (
    <div className="px-3 py-2 flex flex-wrap gap-1">
      {AU_STATES.map(({ code, bbox }) => (
        <button
          key={code}
          type="button"
          onClick={() => handleStateClick(code, bbox)}
          className={`px-2 py-0.5 rounded text-xs font-medium border transition-all ${
            selectedState === code
              ? 'bg-blue-600 border-blue-500 text-white'
              : 'bg-gray-100 border-gray-300 text-gray-500 hover:border-gray-400 hover:text-gray-700'
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  )
}
